import domainByEnv from '@utils/domainByEnv';
import { I_FlightInfos } from '@Redux/search/interfaces';

// 整理此頁要送去 GA 的資料
export const formatGA = (data: I_FlightInfos[], RtowText: string) => {
    return data.map((item, i) => {
        const depDateTime = item.ItineraryInfos[0]?.DepDateTime || '';
        const depMonth = depDateTime.substring(5, 7); // 提取 "YYYY-MM-DD" 的月份部分
        // 計算天數差異
        const depDate = new Date(item.ItineraryInfos[0]?.DepDateTime.split('T')[0]); // 去程日期
        const returnDate = new Date(item.ItineraryInfos[1]?.DepDateTime.split('T')[0]); // 回程日期
        const dayDifference = item.ItineraryInfos.length > 1
            ? (Math.ceil((returnDate.getTime() - depDate.getTime()) / (1000 * 60 * 60 * 24))) + 1
            : 0; // 相差天數，僅考慮日期部分
        const formattedDayDifference = dayDifference < 10 ? `0${dayDifference}` : dayDifference; // 格式化天數為雙位數

        return {
            item_id: `${item.ItineraryInfos[0]?.DepCountry}-${item.ItineraryInfos[0]?.DepCity}_` +
                `${item.ItineraryInfos[0]?.ArrCountry}-${item.ItineraryInfos[0]?.ArrCity}_` +
                `${depMonth}_` +
                `${formattedDayDifference}`,
            item_name: `${item.ItineraryInfos[0]?.DepCityName}-${item.ItineraryInfos[0]?.ArrCityName} ${RtowText}`,
            affiliation: item.FareInfos[0]?.TicketSupplier,
            currency: 'TWD',
            discount: 0,
            index: i + 1,
            item_brand: 'Lion Travel',
            item_category: 'B2CWebtk',
            price: item.FareInfos[0]?.AdtPrice,
        }
    });
};

// 排序機票搜尋結果: lowest price | lowest time
export const sorting = (data: I_FlightInfos[], type: 'price' | 'time'): I_FlightInfos[] => {
    if (!data || data?.length === 0) return data;

    const newInfo: I_FlightInfos[] = [];
    let lowestPrice = 0;
    let lowestTime = 0;

    data.forEach((item, index) => {
        const timeStringArr = item.ItineraryInfos.map((itinerary) => itinerary.TotalFlyDuration);

        const timeInSeconds = countTime(timeStringArr);

        if (index < 1) {
            lowestPrice = item.FareInfos[0].AdtPrice;
            lowestTime = timeInSeconds;
        } else {
            if (item.FareInfos[0].AdtPrice < lowestPrice) lowestPrice = item.FareInfos[0].AdtPrice;
            if (timeInSeconds < lowestTime) lowestTime = timeInSeconds;
        }

        newInfo.push({ ...data[index], lowTime: timeInSeconds });
    });

    newInfo.forEach((item) => {
        item.isLowPrice = item.FareInfos[0].AdtPrice === lowestPrice ? true : false;
        item.lowstTime = item.lowTime === lowestTime ? true : false;
    });

    return type === 'price' ? sorByPrice(newInfo) : sortByTime(newInfo);
};

// 取得航班明細頁連結
interface I_ProductKeys {
    transactionKey: string;
    searchKey: string;
    fareFamilyKey: string;
}
export const getProductUrl = ({ transactionKey, searchKey, fareFamilyKey }: I_ProductKeys) => {
    const urlParams = new URLSearchParams(window.location.search);
    const url = urlParams.toString();
    return `${domainByEnv(
        false
    )}/order/confirmation?${url}&TransactionKey=${transactionKey}&SearchKey=${searchKey}&FlightFareInfoKey=${fareFamilyKey}`;
};

// Helper Functions =============================
// 時間轉成秒數
function changeSeconds(time: string) {
    // 三種狀況 10h10m, 10h, 10m
    let hourStr = '0';
    let minStr = '0';

    if (time.endsWith('m')) {
        if (time.includes('h')) {
            // 10h10m
            hourStr = time.split(/[a-zA-Z]/g, 2)[0];
            minStr = time.split(/[a-zA-Z]/g, 2)[1];
        } else {
            // 10m
            minStr = time.replace('m', '');
        }
    } else {
        // 10h
        hourStr = time.replace('h', '');
    }

    return parseInt(hourStr) * 60 + parseInt(minStr);
}

// 計算最省時
function countTime(timeArr: string[]) {
    return timeArr.reduce((acc, cur) => acc + changeSeconds(cur), 0);
}

// 低價排序
function sorByPrice(data: I_FlightInfos[]) {
    return data.sort(
        (a: I_FlightInfos, b: I_FlightInfos) => a.FareInfos[0].AdtPrice - b.FareInfos[0].AdtPrice
    );
}

// 省時排序
function sortByTime(data: I_FlightInfos[]) {
    return data.sort((a: any, b: any) => a.lowTime - b.lowTime);
}
